<template>
  <div class="card">
    <div class="card-body" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <form @submit="submit" class="add-edit-form product-form">
              <div class="row">
                <div class="col-lg-6">
                  <label for>
                    <span>Name:</span>
                    <input v-model="admin.name" type="text" class="form-control" />
                  </label>
                  <label for>
                    <span>Email:</span>
                    <input v-model="admin.email" type="text" class="form-control" />
                  </label>
                  <label for>
                    <span>Password:</span>
                    <input v-model="admin.password" type="password" class="form-control" />
                  </label>
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">{{toEdit ? 'Update' : 'Save'}}</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
          <div class="col-lg-6"></div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Admin from '@/models/admin'
export default{
  name: 'AdminForm',
  data () {
    return {
      admin: new Admin()
    }
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetchAdmin()
    }
  },
  methods: {
    fetchAdmin () {
      this.$store.dispatch('fetchAdmin', this.$route.params.id)
        .then((result) => {
          this.admin = new Admin(result.data.admin)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    },
    submit (event) {
      event.preventDefault()
      var admin = this.admin
      var functionName = 'createAdmin'
      var successText = 'created'
      if (this.toEdit) { functionName = 'editAdmin'; successText = 'edited' }
      this.$store.dispatch(functionName, admin)
        .then(() => {
          this.$router.push('/admins')
          this.$toast.success('Admin ' + successText + ' successfully')
        })
        .catch((err) => {
          console.log(err.response)
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 767px) {
  .cat-div {
    width: 100% !important;
  }
}
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminForm.vue